/** Title slide variant — pink→gold accent lines flanking the headline. */
import type { VariantProps } from '../registry';

export function TitleVariant({ slide }: VariantProps) {
  const text = slide.contentText || 'Title';
  return (
    <div className="preview-slide-content relative flex flex-col items-center gap-6">
      <div className="preview-title-halo" aria-hidden />
      <div className="preview-accent-line" />
      <p className="preview-slide-title">{text}</p>
      <div className="preview-accent-line" />
    </div>
  );
}
